// Modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { routing } from './app.routes';
import { HttpClientModule } from '@angular/common/http'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

// Components
import { AppComponent } from './app.component';
import { CadetapplicationformComponent } from './cadetapplicationform/cadetapplicationform.component';
import { CadethomepageComponent } from './cadethomepage/cadethomepage.component';
import { CadetpreviewapplicationformComponent } from './cadetpreviewapplicationform/cadetpreviewapplicationform.component';
import { CadetconfirmationapplicationComponent } from './cadetconfirmationapplication/cadetconfirmationapplication.component';

// Services
import { CountrieslistService } from './_services/countrieslist.service';
import { DobcalculatorService } from './_services/dobcalculator.service';
import { CadetapplicationpreviewService } from './_services/cadetapplicationpreview.service';

@NgModule({
  declarations: [
    AppComponent,
    CadetapplicationformComponent,
    CadethomepageComponent,
    CadetpreviewapplicationformComponent,
    CadetconfirmationapplicationComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    routing,
    RecaptchaFormsModule,
    NgbModule.forRoot(),
    RecaptchaModule.forRoot()
  ],
  providers: [CountrieslistService, DobcalculatorService, CadetapplicationpreviewService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts